import React from 'react';
import { CrossLinkStrip } from './CrossLinkStrip';
import { RELATED_LINK_SETS } from '../../data/relatedLinkSets';

/**
 * RelatedLinks
 * ------------
 * Thin wrapper that renders a curated <CrossLinkStrip> from a named theme
 * in relatedLinkSets.js. Used to give genuinely-orphan standalone pages a
 * block of >=3 relevant internal links so nothing is stranded for crawlers.
 *
 * Usage:  <RelatedLinks theme="costs" />
 */
export const RelatedLinks = ({ theme, heading = 'Keep exploring', testId }) => {
  const items = RELATED_LINK_SETS[theme];
  if (!items || items.length === 0) return null;
  return (
    <CrossLinkStrip
      heading={heading}
      items={items}
      testId={testId || `related-links-${theme}`}
    />
  );
};

export default RelatedLinks;
